/**
 * @file フック：メディアクエリ関連
 */

// ライブラリ読み込み
import { useEffect, useState } from "react";

/**
 * メディアクエリ Range Syntax
 */
export const mediaQuery = {
    sp: "(max-width: 600px)",
    spWide: "(min-width: 600px) and (max-width: 768px)",
    tablet: "(min-width: 768px) and (max-width: 950px)",
    pc: "(min-width: 950px) and (max-width: 1200px)",
    pcWide: "(min-width: 1200px)",
    pcOrPcWide: "(min-width: 950px)",
};

/**
 * メディアクエリフック
 */
export const useMediaQuery = (query: string) => {
    // 引数をフォーマット
    const formattedQuery = `${query}`;
    // MediaQueryListのmatch値（boolean）
    const [match, setMatch] = useState(matchMedia(formattedQuery).matches);
    useEffect(() => {
        // MediaQueryList
        const mql = matchMedia(formattedQuery);
        // シリアライズされたメディアクエリが取得できない場合にエラーログを出力
        if (mql.media === "not all" || mql.media === "invalid") {
            console.error("useMediaQuery Error: Invalid media query");
        }
        // メディアクエリの当てはまる範囲が変更された場合の処理
        mql.onchange = (e) => {
            setMatch(e.matches);
        };
        return () => {
            mql.onchange = null;
        };
    }, [formattedQuery, setMatch]);
    // queryで指定したメディアクエリに当てはまるかどうかをbooleanで返す
    return match;
};
